import React, { Component } from "react";
import {
  Grid,
  Box,
  Typography,
  Avatar,
  Button,
  TextField,
  Card,InputAdornment
} from "@mui/material";
import Navbar from "../../Home/Container/navCon";
import Footer from "../../Home/components/footer";
import { Link } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Snackbar from "../../../common/snackbar/components/snackbar";
class ProfilePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: this.props.login.name,
      email: "",
      mobile: "",
      password: "",
      emailError: "",
      mobileError: "",
      profilePic: this.props.login.profile_pic,
      oldpassword: "",
      uploadedProfilePic: null,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
  };
  handlePasswordToggle = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };


  handleEmailChange = (e) => {
    this.setState({ email: e.target.value });
  };
  componentDidMount() {
    console.log(this.props.login.profile_pic);
  }

  render() {
    const {
      name,
      email,
      mobile,
      password,
      emailError,
      mobileError,
      oldpassword,
      uploadedProfilePic,
      profilePic,
    } = this.state;
    const { snackbar, close_snack_bar } = this.props;
    return (
      <>
        <Navbar />
        <Snackbar
          open={snackbar.response_received}
          close_snack_bar={close_snack_bar}
          message={snackbar.message}
        />
        <Box
          sx={{
            padding: "20px",
            backgroundColor: "#CED5DF",
            minHeight: "60vh",
          }}
        >
       
          <Card
            sx={{
              padding: "25px",
              borderRadius: "10px",
              backgroundColor: "#EEEEEE",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              height: "auto",
            }}
          >
            <Grid container spacing={2} sx={{ height: "100%" }}>
              {/* Left side */}
              <Grid item xs={12} md={5}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <Avatar
                    src={
                      uploadedProfilePic
                        ? URL.createObjectURL(uploadedProfilePic)
                        : profilePic
                    }
                    sx={{
                      width: "300px",
                      height: "300px",
                      cursor: "pointer",
                    }}
                  />
                  <Button
                    variant="contained"
                    component="label"
                    sx={{
                      marginTop: "20px",
                      backgroundColor: "#866CD8",
                      color: "white",
                      textTransform: "none",
                    }}
                  >
                    Upload Image
                    <input
                      type="file"
                      hidden
                      accept=".png,.jpg,.jpeg,image/png,image/jpg,image/jpeg"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          this.setState({ uploadedProfilePic: file }, () => {
                            this.props.updateProfilePic(
                              this.props.login.token,
                              this.props.login.user_id,
                              file
                            );
                          });
                        }
                      }}
                    />
                  </Button>
                </Box>
              </Grid>

              {/* Divider */}
              <Grid
                item
                xs={12}
                md={1}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Box
                  sx={{
                    width: "2px",
                    height: "100%",
                    backgroundColor: "grey",
                  }}
                />
              </Grid>
              {/* Right side */}
              <Grid item xs={12} md={5}>
                <Box sx={{ paddingLeft: "20px", height: "100%" }}>
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{
                      color: "black",
                      textAlign: "left",
                      fontFamily: "serif",
                      fontSize: "28px",
                      marginBottom: "10px",
                    }}
                  >
                    My Profile
                  </Typography>
                  <Typography
                    variant="body1"
                    component="div"
                    sx={{
                      color: "grey",
                      textAlign: "left",
                      marginBottom: "20px",
                    }}
                  >
                    Here is your profile which is everything about you.
                  </Typography>
                  <form onSubmit={this.handleSubmit}>
                    <TextField
                      fullWidth
                      label="Enter Your Name"
                      value={this.props.login.name}
                      onChange={(e) => this.setState({ name: e.target.value })}
                      sx={{
                        mb: 2,
                        backgroundColor: "#f0f0f0",
                        borderRadius: "5px",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "5px",
                        },
                      }}
                    />
                    <TextField
                      fullWidth
                      label="Enter Your Email Address"
                      value={this.props.login.email}
                      // onChange={this.handleEmailChange}
                      // error={Boolean(emailError)}
                      // helperText={emailError}
                      sx={{
                        mb: 2,
                        backgroundColor: "#f0f0f0",
                        borderRadius: "5px",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "5px",
                        },
                      }}
                    />
                    <TextField
                      fullWidth
                      label="Enter Mobile Number"
                      value={this.props.login.mobile}
                      // onChange={(e) => this.setState({ mobile: e.target.value })}
                      // error={Boolean(mobileError)}
                      // helperText={mobileError}
                      sx={{
                        mb: 2,
                        backgroundColor: "#f0f0f0",
                        borderRadius: "5px",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "5px",
                        },
                      }}
                    />
                    <TextField
                      fullWidth
                      label="Old Password"
                      type="password"
                      value={oldpassword}
                      onChange={(e) =>
                        this.setState({ oldpassword: e.target.value })
                      }
                      sx={{
                        mb: 2,
                        backgroundColor: "#f0f0f0",
                        borderRadius: "5px",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "5px",
                        },
                      }}
                    />
                    <TextField
                      fullWidth
                      label="New Password"
                      type={this.state.showPassword ? "text" : "password"} // Toggle based on state
                      value={password}
                      onChange={(e) =>
                        this.setState({ password: e.target.value })
                      }
                      sx={{
                        mb: 2,
                        backgroundColor: "#f0f0f0",
                        borderRadius: "5px",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "5px",
                        },
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Button onClick={this.handlePasswordToggle}>
                              {this.state.showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </Button>
                          </InputAdornment>
                        ),
                      }}
                    />

                    <Link to="/">
                      <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{
                          marginTop: "10px",
                          backgroundColor: "#866CD8",
                          color: "white",
                          padding: "10px",
                        }}
                        onClick={(e) => {
                          this.props.updateProfile(
                            this.props.login.token,
                            this.props.login.user_id,
                            this.state.name,
                            this.state.oldpassword,
                            this.state.password
                          );
                        }}
                      >
                        Save Changes
                      </Button>
                    </Link>
                  </form>
                </Box>
              </Grid>
            </Grid>
          </Card>
        </Box>
        <Footer />
      </>
    );
  }
}

export default ProfilePage;
